export const SEARCH_DELAY_IN_MS: number = 500
